<app-navbar [title]="pageTitle">
	<a routerLink="./history" class="btn btn-secondary me-3"> <i class="fas fa-history"></i> Historia </a>
	<!-- <button class="btn btn-warning me-3" *ngIf="pageFunction=='edit' && !editable" (click)="deleteAsk()">Usuń</button> -->
	<button
		class="btn btn-primary me-3"
		*ngIf="(pageFunction === 'edit' && editable) || pageFunction === 'add'"
		(click)="submit()"
	>
		Zapisz
	</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="editUnlock()">
		Edycja
	</button>
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4" [class.container--fluid]="isSalaryTab">
	<mat-tab-group
		mat-align-tabs="start"
		mat-stretch-tabs="false"
		dynamicHeight
		animationDuration="0ms"
		[selectedIndex]="selectedTabIndex"
		(selectedIndexChange)="onTabChange($event)"
	>
		<mat-tab label="Podstawowe">
			<ng-template matTabContent>
				<form class="my-4" (submit)="submit()">
					<fieldset [disabled]="pageFunction !== 'add' && !editable">
						<div class="form-floating mb-3">
							<input class="form-control" name="firstName" [(ngModel)]="data.firstName" id="firstName" />
							<label class="required" for="firstName">Imię</label>
						</div>
						<div class="form-floating mb-3">
							<input class="form-control" name="lastName" [(ngModel)]="data.lastName" id="lastName" />
							<label class="required" for="lastName">Nazwisko</label>
						</div>
						<div class="form-floating mb-3">
							<select class="form-select" id="type" [(ngModel)]="data.type" name="type">
								<option value="">(brak)</option>
								<option value="{{ item.id }}" *ngFor="let item of types">{{ item.name }}</option>
							</select>
							<label for="type">Status</label>
						</div>
						<div class="form-floating mb-3">
							<input
								type="date"
								class="form-control"
								name="birthdate"
								[(ngModel)]="data.birthdate"
								id="birthdate"
								required
							/>
							<label for="birthdate">Data urodzenia</label>
						</div>
						<div class="form-floating mb-3">
							<input
								class="form-control"
								name="phonePrivate"
								[(ngModel)]="data.phonePrivate"
								id="phonePrivate"
							/>
							<label class="required" for="phonePrivate">Telefon prywatny</label>
						</div>
						<div class="form-floating mb-3">
							<input
								class="form-control"
								name="phoneBusiness"
								[(ngModel)]="data.phoneBusiness"
								id="phoneBusiness"
							/>
							<label for="phoneBusiness">Telefon służbowy</label>
						</div>
						<div class="form-floating mb-3">
							<input
								type="email"
								class="form-control"
								name="emailPrivate"
								[(ngModel)]="data.emailPrivate"
								id="emailPrivate"
							/>
							<label class="required" for="emailPrivate">E-mail prywatny</label>
						</div>
						<div class="form-floating mb-3">
							<input
								type="email"
								class="form-control"
								name="emailBusiness"
								[(ngModel)]="data.emailBusiness"
								id="emailBusiness"
							/>
							<label for="emailBusiness">E-mail służbowy</label>
						</div>
						<div class="form-floating mb-3">
							<select
								class="form-select"
								id="nearest_city"
								[(ngModel)]="data.nearest_city"
								name="nearest_city"
							>
								<option value="">(brak)</option>
								<option value="{{ item.id }}" *ngFor="let item of cities">{{ item.name }}</option>
							</select>
							<label for="nearest_city">Najbliższe duże miasto</label>
						</div>
						<div class="form-floating mb-3">
							<select
								class="form-select"
								id="chronically_ill"
								[(ngModel)]="data.chronically_ill"
								name="chronically_ill"
							>
								<option value="0">Nie</option>
								<option value="1">Tak</option>
							</select>
							<label for="chronically_ill">Przewlekle chory</label>
						</div>
						<div class="form-floating mb-3">
							<input
								type="number"
								min="0"
								max="10"
								class="form-control"
								id="rate"
								name="rate"
								[(ngModel)]="data.rate"
							/>
							<label for="rate">Ocena</label>
						</div>
						<div class="form-floating mb-3">
							<textarea
								class="form-control"
								id="comments"
								name="comments"
								[(ngModel)]="data.comments"
							></textarea>
							<label for="comments">Uwagi</label>
						</div>
						<div class="form-floating mb-3">
							<textarea
								class="form-control"
								id="salaryComments"
								name="salaryComments"
								[(ngModel)]="data.salaryComments"
							></textarea>
							<label for="salaryComments">Uwagi do wynagrodzenia</label>
						</div>
						<mat-form-field appearance="outline" class="w-100 mb-3">
							<mat-label>Użytkownik</mat-label>
							<input type="text" matInput [formControl]="userControl" [matAutocomplete]="userAuto" />
							<mat-autocomplete
								#userAuto="matAutocomplete"
								[displayWith]="displayUser"
								(optionSelected)="onUserSelected($event.option.value)"
							>
								<mat-option [value]="null">(brak)</mat-option>
								@for (user of filteredUsers; track user.id) {
									<mat-option [value]="user">
										{{ user.firstName }} {{ user.lastName }} | {{ user.email }}
									</mat-option>
								}
							</mat-autocomplete>
						</mat-form-field>
					</fieldset>
				</form>
			</ng-template>
		</mat-tab>

		@if (pageFunction !== 'add') {
			<mat-tab label="Stawki">
				<ng-template matTabContent>
					<app-tourist-guides-rates [touristGuideId]="data.id"></app-tourist-guides-rates>
				</ng-template>
			</mat-tab>

			<mat-tab label="Konta bankowe">
				<ng-template matTabContent>
					<div class="my-4">
						<div class="d-flex justify-content-between align-items-center mb-3">
							<h2 class="h5 mb-0">Konta bankowe</h2>
							<button
								mat-flat-button
								color="primary"
								type="button"
								[disabled]="!canAddBankAccount"
								(click)="addBankAccount()"
							>
								<mat-icon><i class="fa-solid fa-plus"></i></mat-icon>
								Dodaj konto
							</button>
						</div>

						@if (data.bankAccounts.length === 0) {
							<p class="text-muted">Brak kont bankowych. Kliknij „Dodaj konto”, aby dodać.</p>
						}

						@for (account of data.bankAccounts; track $index) {
							<mat-card class="mb-3">
								<mat-card-content>
									<div class="row g-3">
										<div class="col-md-6">
											<mat-form-field appearance="outline" class="w-100">
												<mat-label>Numer konta (IBAN)</mat-label>
												<input
													matInput
													[(ngModel)]="account.accountNumber"
													[ngModelOptions]="{ standalone: true }"
													[disabled]="!editable || account.sameAsSalaryAccount"
													placeholder="PL61109010140000071219812874"
												/>
											</mat-form-field>
										</div>
										<div class="col-md-4">
											<mat-form-field appearance="outline" class="w-100">
												<mat-label>Typ konta</mat-label>
												<mat-select
													[(ngModel)]="account.type"
													[ngModelOptions]="{ standalone: true }"
													[disabled]="!editable"
													(selectionChange)="onBankAccountTypeChange(account)"
												>
													@for (option of bankAccountTypes; track option.value) {
														<mat-option
															[value]="option.value"
															[disabled]="isBankAccountTypeTaken(option.value, account)"
														>
															{{ option.label }}
														</mat-option>
													}
												</mat-select>
											</mat-form-field>
										</div>
										<div class="col-md-2 d-flex align-items-center justify-content-end">
											<button
												mat-icon-button
												color="warn"
												type="button"
												[disabled]="!editable"
												(click)="removeBankAccount($index)"
												aria-label="Usuń konto"
												title="Usuń konto"
											>
												<mat-icon><i class="fa-solid fa-trash"></i></mat-icon>
											</button>
										</div>
									</div>
									@if (account.type !== 'salary') {
										<mat-checkbox
											[(ngModel)]="account.sameAsSalaryAccount"
											[ngModelOptions]="{ standalone: true }"
											[disabled]="!editable"
											(ngModelChange)="onSameAsSalaryChange(account)"
										>
											Taki sam jak konto wynagrodzenia
										</mat-checkbox>
									}
								</mat-card-content>
							</mat-card>
						}
					</div>
				</ng-template>
			</mat-tab>

			<mat-tab label="Wynagrodzenie">
				<ng-template matTabContent>
					<app-tourist-guides-salary-list [touristGuideId]="data.id"></app-tourist-guides-salary-list>
				</ng-template>
			</mat-tab>

			<mat-tab label="Integracja">
				<ng-template matTabContent>
					<app-tourist-guides-integration [touristGuideId]="data.id"></app-tourist-guides-integration>
				</ng-template>
			</mat-tab>
		}
	</mat-tab-group>
</div>
